
shadow$export("default",orgx.demonstration.component);
shadow$export("component",orgx.demonstration.component);